import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

export const toast = {
  success: (message: string) => {
    return Toast.fire({
      icon: 'success',
      title: message,
    });
  },

  error: (message: string) => {
    return Toast.fire({
      icon: 'error',
      title: message,
    });
  },

  warning: (message: string) => {
    return Toast.fire({
      icon: 'warning',
      title: message,
    });
  },

  info: (message: string) => {
    return Toast.fire({
      icon: 'info',
      title: message,
    });
  },
};

export const alert = {
  success: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'success',
      title,
      text: message,
      confirmButtonColor: '#10b981',
      confirmButtonText: 'OK',
    });
  },

  error: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'error',
      title,
      text: message,
      confirmButtonColor: '#ef4444',
      confirmButtonText: 'OK',
    });
  },

  warning: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'warning',
      title,
      text: message,
      confirmButtonColor: '#f59e0b',
      confirmButtonText: 'OK',
    });
  },

  info: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'info',
      title,
      text: message,
      confirmButtonColor: '#3b82f6',
      confirmButtonText: 'OK',
    });
  },

  confirm: (title: string, message?: string) => {
    return Swal.fire({
      icon: 'question',
      title,
      text: message,
      showCancelButton: true,
      confirmButtonColor: '#10b981',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar',
    });
  },
};

export const loading = {
  show: (message: string = 'A carregar...') => {
    Swal.fire({
      title: message,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  },

  hide: () => {
    Swal.close();
  },
};
